import { createSlice } from '@reduxjs/toolkit';

// Utility to load contentMap from localStorage
const loadContentMap = () => {
  try {
    const stored = localStorage.getItem('contentMap');
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
};

// Initial state: contentMap is a hashmap { [activityId]: content }
const initialState = {
  contentMap: loadContentMap(), // { [activityId]: content }
};

const contentSlice = createSlice({
  name: 'content',
  initialState,
  reducers: {
    // Set or update content for a specific activityId
    setActivityContent(state, action) {
      const { activityId, content } = action.payload;
      state.contentMap[activityId] = content;
      // Persist to localStorage
      localStorage.setItem('contentMap', JSON.stringify(state.contentMap));
    },
    // Optionally, clear all content (e.g., on logout)
    clearContent(state) {
      state.contentMap = {};
      localStorage.removeItem('contentMap');
    },
  },
});

export const { setActivityContent, clearContent } = contentSlice.actions;

// Selector to get content for a specific activityId
export const selectContentByActivityId = (state, activityId) =>
  Object.prototype.hasOwnProperty.call(state.content.contentMap, activityId)
    ? state.content.contentMap[activityId]
    : null;

export default contentSlice.reducer;
